import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const navLinks = [
{ label: 'Services', href: '#services' },
{ label: 'Process', href: '#process' },
{ label: 'Results', href: '#results' },
{ label: 'Pricing', href: '#pricing' },
{ label: 'FAQ', href: '#faq' }];


export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNavClick = (href) => {
    setMobileOpen(false);
    setTimeout(() => {
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 150);
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled ?
      'backdrop-blur-xl bg-white/70 border-b border-slate-200/50 shadow-sm' :
      'bg-transparent'}`
      }>

      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-16 md:h-20">
        <a href="#hero" onClick={() => handleNavClick('#hero')} data-testid="header-logo" className="flex items-center gap-2">
          <img
            src="https://customer-assets.emergentagent.com/job_instagram-growth-11/artifacts/849dp4pm_Big_Jaguar_Logo-removebg-preview.png"
            alt="Big Jaguar"
            className="h-20 md:h-20 w-auto" />

        </a>

        <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
          {navLinks.map((link) =>
          <button
            key={link.href}
            onClick={() => handleNavClick(link.href)}
            data-testid={`nav-${link.label.toLowerCase()}`}
            className="text-sm text-slate-600 hover:text-slate-900 transition-colors font-medium"
            style={{ fontFamily: 'Manrope, sans-serif' }}>

              {link.label}
            </button>
          )}
          <button
            onClick={() => handleNavClick('#contact')}
            data-testid="header-cta-button"
            className="bg-slate-900 text-white rounded-full px-6 py-2.5 text-sm font-medium hover:bg-slate-800 transition-colors">

            Get More Customers
          </button>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden p-2 text-slate-700">

          {mobileOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      <AnimatePresence>
        {mobileOpen &&
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          exit={{ opacity: 0, height: 0 }}
          className="md:hidden bg-white/95 backdrop-blur-xl border-b border-slate-200/50"
          data-testid="mobile-nav">

            <div className="px-6 py-4 flex flex-col gap-3">
              {navLinks.map((link) =>
            <button
              key={link.href}
              onClick={() => handleNavClick(link.href)}
              className="text-left text-sm text-slate-600 hover:text-slate-900 transition-colors font-medium py-2">

                  {link.label}
                </button>
            )}
              <button
              onClick={() => handleNavClick('#contact')}
              data-testid="mobile-cta-button"
              className="bg-slate-900 text-white rounded-full px-6 py-2.5 text-sm font-medium hover:bg-slate-800 transition-colors mt-2 w-fit">

                Get More Customers
              </button>
            </div>
          </motion.div>
        }
      </AnimatePresence>
    </header>);

};